import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  exportProviderDistributionReport,
  exportProviderProvinceDistributionReport,
  getProviderDistributionReports,
  getProviderProvinceDistributionReports,
} from "store/provider-reports/p-report-action"
import {
  getProviderIps,
  getProviderItemCategories,
  getProviderProvinces,
  getProviderWarehouses,
} from "store/provider-dashboard/provider-dashboard-action"
import useSearch from "hooks/useSearch"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import ProviderDistributionListComponent from "components/ProviderReports/Distribution"
import ProviderProvinceDistributionListComponent from "components/ProviderReports/IPDistribution"

const ProviderProvinceDistributionReportList = () => {
  // Meta Title
  document.title = "IP Distribution Reports"

  const dispatch = useDispatch()

  // Retrieve distributions data from Redux store
  const distributions = useSelector(
    state => state.providerReports.providerProvicneDistributionReport
  )

  // Current status of the export process for the report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.providerReports.providerProvinceExportDistributionReport
  )
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(20)
  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.PROVIDER_IP_DISTRIBUTION
  )


  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProviderProvinceDistributionReports(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getProviderProvinceDistributionReports(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getProviderProvinceDistributionReports(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch data for filter select box
  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getProviderProvinces())
    dispatch(getProviderIps())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getProviderProvinceDistributionReports(
        undefined,
        undefined,
        undefined,
        search,
        data
      )
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportProviderProvinceDistributionReport(pageNumber,
        according,
        search,
        advnacedSearch, visibleKeys))
  }

  return (
    <React.Fragment>
      <Breadcrumbs
        title={"Provider"}
        breadcrumbItem={"IPs Distribution Report"}
      />
      {/* Provider IPs Distribution List Component  */}
      <ProviderProvinceDistributionListComponent
        data={distributions?.data}
        error={distributions?.error}
        loading={distributions?.loading}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportTransaction={exportStatus}
        onPageClick={onPageClick}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default ProviderProvinceDistributionReportList
